<app-pan-card [isPageContainer]="true" [pageContainerSize]="'xl'" [header]="'Home'">Welcome to the Panoptyc application!</app-pan-card>
